import Button from "../../components/shared/Button";

const ImgCourseProg = ({ lessonNumber, bookImage }) => {
  return (
    <div className="sm:absolute top-52 right-8">
      <div className="sm:w-[20rem]">
        <div className="">
          <img src={bookImage} alt="" />
        </div>
        <div className="bg-white flex flex-col gap-2 px-4 pt-2 pb-10">
          <Button
            btnBgColor={"bg-[#3b76db]"}
            btnText={"Continue"}
            padding={"py-2"}
          />
          <div className="flex justify-between">
            <p>Lessons completed:</p> <p>1/{lessonNumber}</p>
          </div>
          <div className="flex justify-between">
            <p>Course progress:</p> <p>1.92%</p>
          </div>
          <div className="h-2 bg-gray-300 rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default ImgCourseProg;
